var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKamatera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "4.57 0.28 22.05 31.45",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#7bdef4",
    stroke: "#57afde",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7 31.6l-11-5.5v-4.9l11 5.4z",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 31.6l11-5.5v-4.9l-11 5.4z",
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 15.6l11 5.4v5l-11-5.5z",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7 15.6L4.7 21v5l11-5.5z",
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7 24l-11-5.5v-4.9l11 5.4z",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 24l11-5.5v-4.9l-11 5.4z",
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8l11 5.5v4.9l-11-5.5z",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7 8l-11 5.5v4.9l11-5.5z",
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7 16.4L4.7 11V6l11 5.5z",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 16.4l11-5.4V6l-11 5.5z",
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5.4l11 5.5v4.9l-11-5.4z",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7.4l-11 5.5v4.9l11-5.4z",
    opacity: 0.69
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjQuNTcgMC4yOCAyMi4wNSAzMS40NSI+PGcgZmlsbD0iIzdiZGVmNCIgc3Ryb2tlPSIjNTdhZmRlIiBzdHJva2Utd2lkdGg9Ii4yNSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIj48cGF0aCBkPSJtMTUuNyAzMS42LTExLTUuNXYtNC45bDExIDUuNHoiIG9wYWNpdHk9Ii41NiIvPjxwYXRoIGQ9Im0xNS41IDMxLjYgMTEtNS41di00LjlsLTExIDUuNHoiIG9wYWNpdHk9Ii4yOCIvPjxwYXRoIGQ9Im0xNS41IDE1LjYgMTEgNS40djVsLTExLTUuNXoiIG9wYWNpdHk9Ii41NiIvPjxwYXRoIGQ9Ik0xNS43IDE1LjYgNC43IDIxdjVsMTEtNS41eiIgb3BhY2l0eT0iLjY5Ii8+PHBhdGggZD0ibTE1LjcgMjQtMTEtNS41di00LjlsMTEgNS40eiIgb3BhY2l0eT0iLjU2Ii8+PHBhdGggZD0ibTE1LjUgMjQgMTEtNS41di00LjlsLTExIDUuNHoiIG9wYWNpdHk9Ii4yOCIvPjxwYXRoIGQ9Im0xNS41IDggMTEgNS41djQuOWwtMTEtNS41eiIgb3BhY2l0eT0iLjU2Ii8+PHBhdGggZD0ibTE1LjcgOC0xMSA1LjV2NC45bDExLTUuNXoiIG9wYWNpdHk9Ii42OSIvPjxwYXRoIGQ9Ik0xNS43IDE2LjQgNC43IDExVjZsMTEgNS41eiIgb3BhY2l0eT0iLjU2Ii8+PHBhdGggZD0ibTE1LjUgMTYuNCAxMS01LjRWNmwtMTEgNS41eiIgb3BhY2l0eT0iLjI4Ii8+PHBhdGggZD0ibTE1LjUuNCAxMSA1LjV2NC45bC0xMS01LjR6IiBvcGFjaXR5PSIuNTYiLz48cGF0aCBkPSJtMTUuNy40LTExIDUuNXY0LjlsMTEtNS40eiIgb3BhY2l0eT0iLjY5Ii8+PC9nPjwvc3ZnPg==";
export { SvgKamatera as ReactComponent };